// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   WHOLESALE COMMITMENT BY ZONE COMPONENT STYLES
   ============================================ */

body {
	color: #495057;
}

a {
	color: #27405f;
	text-decoration: none;
}

a:hover {
	color: #1d3049;
	text-decoration: underline;
}

/* ============================================
   BUTTON STYLES
   ============================================ */
.btn-primary {
	background-color: #27405f;
	border: 1px solid #27405f;
	font-weight: 600;
	color: white;
	text-align: center;
	height: 40px;
	padding: 0.5rem 1.5rem;
	border-radius: 4px;
	cursor: pointer;
	transition: background-color 0.2s, border-color 0.2s;
}

.btn-primary:hover {
	background-color: #1d3049;
	border-color: #1d3049;
}

/* ============================================
   TABLE STYLES
   ============================================ */
.responsive-table {
	width: 100%;
	margin-bottom: 1.5em;
	border-spacing: 0;
	font-size: 0.9em;
}

th {
	background-color: #27405f;
	border: 1px solid #27405f;
	font-weight: 600;
	text-align: center;
	color: white;
	padding: 0.75rem;
}

td {
	background-color: #ffffff;
	border: 1px solid #e9ecef;
	color: #495057;
	text-align: left;
	padding: 0.5rem;
}

/* ============================================
   FORM LAYOUT STYLES
   ============================================ */
.select2-drop {
	width: 10%;
}

.commitButtonPadding {
	padding-top: 15px;
	float: right;
	padding-right: 25px;
}

/* ============================================
   ALIGNMENT UTILITIES
   ============================================ */
.center-right-alignment {
	width: 100px;
	margin-left: auto;
	margin-right: auto;
	padding-right: 35px;
}

.right-align {
	text-align: right;
}

.color-font-size-align {
	background-color: white;
	font-size: small;
}

.bold-align {
	font-weight: bold;
}

.center-align {
	text-align: center;
}

.input[type="text"] {
	font-weight: bold;
}

/* ============================================
   PRIMENG BUTTON OVERRIDES
   ============================================ */
:host ::ng-deep .p-button {
	font-weight: 600 !important;
	background: #27405f !important;
	border-color: #27405f !important;
}

:host ::ng-deep .p-button:enabled:hover {
	background: #1d3049 !important;
	border-color: #1d3049 !important;
}

:host ::ng-deep .p-button:disabled {
	background: #e9ecef !important;
	color: #6c757d !important;
	border-color: #e9ecef !important;
	opacity: 0.7 !important;
}

/* Legacy UI button support */
:host ::ng-deep .ui-button-text-only .ui-button-text {
	font-weight: bold;
	color: #FFFFFF;
	background: #27405f;
}

/* ============================================
   DATATABLE SPACING
   ============================================ */
:host ::ng-deep .p-datatable table {
	margin-top: 1.5rem;
}

:host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
	background: #27405f !important;
	color: white !important;
	border: 1px solid #27405f !important;
}

:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td {
	border: 1px solid #e9ecef !important;
}

/* ============================================
   PRIMENG 19 SELECT/DROPDOWN OVERRIDES
   ============================================ */
:host ::ng-deep p-dropdown,
:host ::ng-deep p-select,
:host ::ng-deep .p-dropdown,
:host ::ng-deep .p-select {
	display: inline-flex !important;
	width: 100% !important;
	min-width: 120px !important;
	background: #ffffff !important;
	border: 1px solid #ced4da !important;
	border-radius: 4px !important;
}

:host ::ng-deep .p-dropdown:hover,
:host ::ng-deep .p-select:hover {
	border-color: #27405f !important;
}

:host ::ng-deep .p-dropdown-label,
:host ::ng-deep .p-select-label {
	padding: 0.5rem 0.75rem !important;
	color: #495057 !important;
	font-size: 0.9rem !important;
	text-overflow: ellipsis !important;
	overflow: visible !important;
	white-space: nowrap !important;
	min-width: 80px !important;
	visibility: visible !important;
	opacity: 1 !important;
}

/* Selected value display (not placeholder) */
:host ::ng-deep .p-select-label:not(.p-placeholder),
:host ::ng-deep .p-dropdown-label:not(.p-placeholder) {
	color: #495057 !important;
	visibility: visible !important;
	opacity: 1 !important;
}

:host ::ng-deep .p-dropdown-trigger,
:host ::ng-deep .p-select-dropdown {
	width: 2.5rem !important;
	color: #6c757d !important;
	background: transparent !important;
}

:host ::ng-deep .p-dropdown-panel,
:host ::ng-deep .p-select-overlay {
	background: #ffffff !important;
	border: 1px solid #dee2e6 !important;
	border-radius: 4px !important;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
}

:host ::ng-deep .p-dropdown-item,
:host ::ng-deep .p-select-option {
	padding: 0.5rem 1rem !important;
	color: #495057 !important;
}

:host ::ng-deep .p-dropdown-item:hover,
:host ::ng-deep .p-select-option:hover {
	background: #e9ecef !important;
}

:host ::ng-deep .p-dropdown-item.p-highlight,
:host ::ng-deep .p-select-option-selected {
	background: #27405f !important;
	color: #ffffff !important;
}

/* ============================================
   H5 HEADING PADDING
   ============================================ */
.h5-pd {
	padding-top: 10px;
	margin: 0;
	font-weight: 600;
	color: #495057;
}

.commitButtonPadding {
    padding-top: 15px;
    padding-right: 25px;
    float: right;
    position: relative;
    z-index: 10;
    margin-bottom: 20px; 
    clear: both;
}

form::after {
    content: "";
    display: table;
    clear: both;
}`, "",{"version":3,"sources":["webpack://./src/app/wholesale-commitment-by-zone/wholesale-commitment-by-zone.component.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,0BAA0B;AAC3B;;AAEA;;iDAEiD;AACjD;CACC,yBAAyB;CACzB,yBAAyB;CACzB,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;CAClB,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;CAClB,eAAe;CACf,oDAAoD;AACrD;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;iDAEiD;AACjD;CACC,WAAW;CACX,oBAAoB;CACpB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;;iDAEiD;AACjD;CACC,UAAU;AACX;;AAEA;CACC,iBAAiB;CACjB,YAAY;CACZ,mBAAmB;AACpB;;AAEA;;iDAEiD;AACjD;CACC,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;;iDAEiD;AACjD;CACC,2BAA2B;CAC3B,8BAA8B;CAC9B,gCAAgC;AACjC;;AAEA;CACC,8BAA8B;CAC9B,gCAAgC;AACjC;;AAEA;CACC,8BAA8B;CAC9B,yBAAyB;CACzB,gCAAgC;CAChC,uBAAuB;AACxB;;AAEA,6BAA6B;AAC7B;CACC,iBAAiB;CACjB,cAAc;CACd,mBAAmB;AACpB;;AAEA;;iDAEiD;AACjD;CACC,kBAAkB;AACnB;;AAEA;CACC,8BAA8B;CAC9B,uBAAuB;CACvB,oCAAoC;AACrC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;;iDAEiD;AACjD;;;;CAIC,+BAA+B;CAC/B,sBAAsB;CACtB,2BAA2B;CAC3B,8BAA8B;CAC9B,oCAAoC;CACpC,6BAA6B;AAC9B;;AAEA;;CAEC,gCAAgC;AACjC;;AAEA;;CAEC,kCAAkC;CAClC,yBAAyB;CACzB,4BAA4B;CAC5B,kCAAkC;CAClC,4BAA4B;CAC5B,8BAA8B;CAC9B,0BAA0B;CAC1B,8BAA8B;CAC9B,qBAAqB;AACtB;;AAEA,6CAA6C;AAC7C;;CAEC,yBAAyB;CACzB,8BAA8B;CAC9B,qBAAqB;AACtB;;AAEA;;CAEC,wBAAwB;CACxB,yBAAyB;CACzB,kCAAkC;AACnC;;AAEA;;CAEC,8BAA8B;CAC9B,oCAAoC;CACpC,6BAA6B;CAC7B,sDAAsD;AACvD;;AAEA;;CAEC,+BAA+B;CAC/B,yBAAyB;AAC1B;;AAEA;;CAEC,8BAA8B;AAC/B;;AAEA;;CAEC,8BAA8B;CAC9B,yBAAyB;AAC1B;;AAEA;;iDAEiD;AACjD;CACC,iBAAiB;CACjB,SAAS;CACT,gBAAgB;CAChB,cAAc;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf","sourcesContent":["/* ============================================\n   WHOLESALE COMMITMENT BY ZONE COMPONENT STYLES\n   ============================================ */\n\nbody {\n\tcolor: #495057;\n}\n\na {\n\tcolor: #27405f;\n\ttext-decoration: none;\n}\n\na:hover {\n\tcolor: #1d3049;\n\ttext-decoration: underline;\n}\n\n/* ============================================\n   BUTTON STYLES\n   ============================================ */\n.btn-primary {\n\tbackground-color: #27405f;\n\tborder: 1px solid #27405f;\n\tfont-weight: 600;\n\tcolor: white;\n\ttext-align: center;\n\theight: 40px;\n\tpadding: 0.5rem 1.5rem;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\ttransition: background-color 0.2s, border-color 0.2s;\n}\n\n.btn-primary:hover {\n\tbackground-color: #1d3049;\n\tborder-color: #1d3049;\n}\n\n/* ============================================\n   TABLE STYLES\n   ============================================ */\n.responsive-table {\n\twidth: 100%;\n\tmargin-bottom: 1.5em;\n\tborder-spacing: 0;\n\tfont-size: 0.9em;\n}\n\nth {\n\tbackground-color: #27405f;\n\tborder: 1px solid #27405f;\n\tfont-weight: 600;\n\ttext-align: center;\n\tcolor: white;\n\tpadding: 0.75rem;\n}\n\ntd {\n\tbackground-color: #ffffff;\n\tborder: 1px solid #e9ecef;\n\tcolor: #495057;\n\ttext-align: left;\n\tpadding: 0.5rem;\n}\n\n/* ============================================\n   FORM LAYOUT STYLES\n   ============================================ */\n.select2-drop {\n\twidth: 10%;\n}\n\n.commitButtonPadding {\n\tpadding-top: 15px;\n\tfloat: right;\n\tpadding-right: 25px;\n}\n\n/* ============================================\n   ALIGNMENT UTILITIES\n   ============================================ */\n.center-right-alignment {\n\twidth: 100px;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tpadding-right: 35px;\n}\n\n.right-align {\n\ttext-align: right;\n}\n\n.color-font-size-align {\n\tbackground-color: white;\n\tfont-size: small;\n}\n\n.bold-align {\n\tfont-weight: bold;\n}\n\n.center-align {\n\ttext-align: center;\n}\n\n.input[type=\"text\"] {\n\tfont-weight: bold;\n}\n\n/* ============================================\n   PRIMENG BUTTON OVERRIDES\n   ============================================ */\n:host ::ng-deep .p-button {\n\tfont-weight: 600 !important;\n\tbackground: #27405f !important;\n\tborder-color: #27405f !important;\n}\n\n:host ::ng-deep .p-button:enabled:hover {\n\tbackground: #1d3049 !important;\n\tborder-color: #1d3049 !important;\n}\n\n:host ::ng-deep .p-button:disabled {\n\tbackground: #e9ecef !important;\n\tcolor: #6c757d !important;\n\tborder-color: #e9ecef !important;\n\topacity: 0.7 !important;\n}\n\n/* Legacy UI button support */\n:host ::ng-deep .ui-button-text-only .ui-button-text {\n\tfont-weight: bold;\n\tcolor: #FFFFFF;\n\tbackground: #27405f;\n}\n\n/* ============================================\n   DATATABLE SPACING\n   ============================================ */\n:host ::ng-deep .p-datatable table {\n\tmargin-top: 1.5rem;\n}\n\n:host ::ng-deep .p-datatable .p-datatable-thead > tr > th {\n\tbackground: #27405f !important;\n\tcolor: white !important;\n\tborder: 1px solid #27405f !important;\n}\n\n:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td {\n\tborder: 1px solid #e9ecef !important;\n}\n\n/* ============================================\n   PRIMENG 19 SELECT/DROPDOWN OVERRIDES\n   ============================================ */\n:host ::ng-deep p-dropdown,\n:host ::ng-deep p-select,\n:host ::ng-deep .p-dropdown,\n:host ::ng-deep .p-select {\n\tdisplay: inline-flex !important;\n\twidth: 100% !important;\n\tmin-width: 120px !important;\n\tbackground: #ffffff !important;\n\tborder: 1px solid #ced4da !important;\n\tborder-radius: 4px !important;\n}\n\n:host ::ng-deep .p-dropdown:hover,\n:host ::ng-deep .p-select:hover {\n\tborder-color: #27405f !important;\n}\n\n:host ::ng-deep .p-dropdown-label,\n:host ::ng-deep .p-select-label {\n\tpadding: 0.5rem 0.75rem !important;\n\tcolor: #495057 !important;\n\tfont-size: 0.9rem !important;\n\ttext-overflow: ellipsis !important;\n\toverflow: visible !important;\n\twhite-space: nowrap !important;\n\tmin-width: 80px !important;\n\tvisibility: visible !important;\n\topacity: 1 !important;\n}\n\n/* Selected value display (not placeholder) */\n:host ::ng-deep .p-select-label:not(.p-placeholder),\n:host ::ng-deep .p-dropdown-label:not(.p-placeholder) {\n\tcolor: #495057 !important;\n\tvisibility: visible !important;\n\topacity: 1 !important;\n}\n\n:host ::ng-deep .p-dropdown-trigger,\n:host ::ng-deep .p-select-dropdown {\n\twidth: 2.5rem !important;\n\tcolor: #6c757d !important;\n\tbackground: transparent !important;\n}\n\n:host ::ng-deep .p-dropdown-panel,\n:host ::ng-deep .p-select-overlay {\n\tbackground: #ffffff !important;\n\tborder: 1px solid #dee2e6 !important;\n\tborder-radius: 4px !important;\n\tbox-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;\n}\n\n:host ::ng-deep .p-dropdown-item,\n:host ::ng-deep .p-select-option {\n\tpadding: 0.5rem 1rem !important;\n\tcolor: #495057 !important;\n}\n\n:host ::ng-deep .p-dropdown-item:hover,\n:host ::ng-deep .p-select-option:hover {\n\tbackground: #e9ecef !important;\n}\n\n:host ::ng-deep .p-dropdown-item.p-highlight,\n:host ::ng-deep .p-select-option-selected {\n\tbackground: #27405f !important;\n\tcolor: #ffffff !important;\n}\n\n/* ============================================\n   H5 HEADING PADDING\n   ============================================ */\n.h5-pd {\n\tpadding-top: 10px;\n\tmargin: 0;\n\tfont-weight: 600;\n\tcolor: #495057;\n}\n\n.commitButtonPadding {\n    padding-top: 15px;\n    padding-right: 25px;\n    float: right;\n    position: relative;\n    z-index: 10;\n    margin-bottom: 20px; \n    clear: both;\n}\n\nform::after {\n    content: \"\";\n    display: table;\n    clear: both;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
